import { useState } from 'react';
import { toast } from 'material-react-toastify';
import { upsertMediaSettings, upsertSettings } from '../../../api/Settings';
import { Settings } from '../../../interfaces/Settings/Settings';
import { Waiting } from '../../Waiting/Waiting';
import { ImageInput } from '../../ImageInput/ImageInput';

interface ImageSettingsInputProps {
  name: string;
  mediaPrefix: string;
  initialValue: Settings;
  onModify: () => void;
}

export const ImageSettingsInput = (props: ImageSettingsInputProps) => {
  const [loading, setLoading] = useState(false);

  const handleUpload = (file?: File) => {
    if (!file) {
      return;
    }

    setLoading(true);
    upsertMediaSettings(props.initialValue.type, props.initialValue.key, file)
      .then(() => {
        toast.success('Medya başarıyla güncellendi');
        props.onModify();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const handleDelete = () => {
    setLoading(true);
    upsertSettings([
      { ...props.initialValue, genericValue: { stringValue: '' } },
    ])
      .then(() => {
        toast.success('Medya başarıyla güncellendi');
        props.onModify();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Waiting open={loading} />
      <ImageInput
        title={props.name}
        existingImage={
          props.initialValue.genericValue?.stringValue
            ? props.mediaPrefix + props.initialValue.genericValue?.stringValue
            : ''
        }
        onUpload={handleUpload}
        onDelete={handleDelete}
      />
    </>
  );
};
